import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  Autocomplete,
  Icon,
} from "@mui/material";
import {
  MdSpaceDashboard,
  MdBusinessCenter,
  MdArticle,
  MdEventRepeat,
  MdAccountBalanceWallet,
  MdReceiptLong,
  MdAssessment,
  MdShowChart,
  MdPeopleAlt,
  MdCorporateFare,
  MdHome,
  MdWorkOutline,
  MdTaskAlt,
  MdAdminPanelSettings,
  MdOutlineDesk,
  MdPayment,
  MdManageAccounts,
  MdSecurity,
  MdMiscellaneousServices,
  MdOutlineApproval,
  MdOutlineHowToReg,
  MdOutlineAccountBalance,
  MdOutlineRequestQuote,
  MdAnalytics,
  MdFactCheck,
  MdOutlineSettings,
  MdPerson,
  MdPostAdd,
} from "react-icons/md";
import { RiGovernmentLine, RiFileTextLine, RiUserSettingsLine } from "react-icons/ri";
import { FiCheckSquare } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import Slider from "react-slick";
import { StyledSnackbar, StyledAlert } from "components/StyledComponents/styledComponents";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from "../../assets/landingimages/images/image.png";
import kotalogo from "../../assets/images/logos/kota-logo.png";
import { useMaterialUIController, setUser, setMiniSidebar } from "context";
import { selectScrollStyle, CustomPaper } from "components/Styles/globalStyles";
// import {
//   MdSpaceDashboard,
//   MdBusinessCenter,
//   MdArticle,
//   MdEventRepeat,
//   MdAccountBalanceWallet,
//   MdReceiptLong,
//   MdAssessment,
//   MdShowChart,
//   MdPeopleAlt,
//   MdCorporateFare,
//   MdHome,
//   MdWorkOutline,
//   MdTaskAlt,
//   MdAdminPanelSettings,
//   MdOutlineDesk,
//   MdPayment,
//   MdManageAccounts,
//   MdSecurity,
//   MdMiscellaneousServices,
//   MdOutlineApproval,
//   MdOutlineHowToReg,
//   MdOutlineAccountBalance,
//   MdOutlineRequestQuote,
//   MdAnalytics,
//   MdFactCheck,
//   MdOutlineSettings,
//   MdPerson,
//   MdPostAdd,
// } from "react-icons/md";
// import { RiGovernmentLine, RiFileTextLine, RiUserSettingsLine } from "react-icons/ri";
// import { FiCheckSquare } from "react-icons/fi";

function LoginPage() {
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");

  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
    customPaging: (i) => (
      <div style={{ color: "#ffffff", fontSize: "clamp(16px, 2vw, 20px)", textAlign: "center" }}>
        {"__"}
      </div>
    ),
  };

  const financeSlides = [
    {
      title: "Seamless Application Tracking",
      description:
        "Track all your loan, insurance, and mutual fund applications with ease and precision.",
    },
    {
      title: "Smart Financial Management",
      description: "Monitor and manage your financial inflows and outflows effectively.",
    },
    {
      title: "Detailed Monthly Insights",
      description: "Access comprehensive monthly financial reports and visual graphs.",
    },
    {
      title: "Streamlined Client Communication",
      description: "Enhance service quality with efficient client communication.",
    },
  ];

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const handleClose = () => setOpen(false);

  const transformData = (data) => {
    const result = [];
    const groupedMap = new Map();
    const moduleIcons = {
      Dashboard: <MdSpaceDashboard />,
      " Bonds": <MdBusinessCenter />,
      "Business Forms": <MdArticle />,
      "Month End": <MdEventRepeat />,
      "Account Masters": <MdAccountBalanceWallet />,
      Vouchers: <MdReceiptLong />,
      "Business Reports": <MdAssessment />,
      Reports: <MdAssessment />,
      HRMS: <MdPeopleAlt />,
      "Head Office": <RiGovernmentLine />,
      "Home Page": <MdHome />,
      EmployeeLetterDesk: <MdWorkOutline />,
      Approvals: <FiCheckSquare />,
      Admin: <MdAdminPanelSettings />,
      "My Desk": <MdOutlineDesk />,
      "Invoice Management": <MdOutlineRequestQuote />,
      "Payment Processing": <MdPayment />,
      MIS: <MdMiscellaneousServices />,
      "Company Setup": <MdOutlineSettings />,
      Access: <MdSecurity />,
      "Provider & DSA Operations": <MdCorporateFare />,
      "Pre Joining": <MdOutlineHowToReg />,
      "Payroll Management": <MdOutlineAccountBalance />,
      Profiles: <MdPerson />,
      Invoices: <MdOutlineRequestQuote />,
      Operation: <MdTaskAlt />,
      Analytics: <MdAnalytics />,
      "Data Setup": <MdPostAdd />,
      "Post Joining": <MdOutlineHowToReg />,
      Payroll: <MdOutlineAccountBalance />,
      "Review & Approvals": <MdFactCheck />,
    };
    data.forEach((item) => {
      const { mainMenuId, mainMenu, subMenuId, subMenuName, routingPath, type, icon, component } =
        item;

      if (!groupedMap.has(mainMenuId)) {
        groupedMap.set(mainMenuId, {
          mainMenuId,
          mainMenu,
          children: [],
        });
      }

      groupedMap.get(mainMenuId).children.push({
        subMenuId,
        subMenuName,
        routingPath,
        type,
        menuKey: subMenuName.toLowerCase().replace(/\s+/g, "-"),
        icon,
        component,
      });
    });

    groupedMap.forEach((group) => {
      if (group.children.length === 1) {
        const child = group.children[0];
        result.push({
          type: "collapse",
          name: group.mainMenu,
          key: child.menuKey,
          route: child.routingPath,
          icon: <Icon fontSize="small">{child.icon}</Icon>,
          component: child.component,
        });
      } else {
        result.push({
          type: "dropdown",
          name: group.mainMenu,
          key: group.mainMenu.toLowerCase().replace(/\s+/g, "-"),
          icon: moduleIcons[group.mainMenu],
          collapse: [
            {
              type: "collapse",
              name: "",
              key: "",
              collapse: group.children.map((child) => ({
                type: "collapse",
                name: child.subMenuName,
                key: child.menuKey,
                route: child.routingPath,
                icon: <Icon fontSize="small">{child.icon}</Icon>,
                component: child.component,
              })),
            },
          ],
        });
      }
    });
    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!username || !password) {
        throw new Error("Please enter username and password");
      }

      // Step 1: Perform login
      const loginUrl = "https://hrms-api.sconexsoft.com/hrms/SconexSoft/login";
      const loginResponse = await fetch(loginUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          employeeCode: username,
          employeePassword: password,
        }),
      });

      if (!loginResponse.ok) {
        const errorMsg = await loginResponse.text();
        throw new Error(errorMsg || "Login failed. Please try again.");
      }

      const loginData = await loginResponse.json();

      // Set cookies with proper expiration
      const expiryDays = rememberMe ? 7 : 1;
      Cookie.set("access_token", loginData.jwtToken, { expires: expiryDays });
      Cookie.set("jwt_token", loginData.jwtToken, { expires: expiryDays });
      Cookie.set("hrms_token", loginData.jwtToken, { expires: expiryDays });
      Cookie.set("employee_id", loginData.employeeId.toString(), { expires: expiryDays });

      // Set user context
      const userObject = {
        ...loginData,
        isAuthenticated: true,
      };
      setUser(dispatch, userObject);
      setAlert("Login successful!", "success");

      // Step 2: Fetch HRMS menu (moduleId: 3)
      try {
        const hrmsResponse = await fetch(
          `${URLs.userManuByModuleId}?employeeId=${loginData.employeeId}&moduleId=3`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${loginData.jwtToken}`,
            },
          }
        );

        if (hrmsResponse.status === 204) {
          throw new Error("You are not authorized to access HRMS");
        }

        if (!hrmsResponse.ok) {
          throw new Error("Failed to fetch HRMS menu details");
        }

        const menuDetails = await hrmsResponse.json();

        if (!menuDetails || menuDetails.length === 0) {
          throw new Error("You are not authorized to access HRMS");
        }

        const transformedMenu = transformData(menuDetails);
        setUser(dispatch, { ...userObject, menu: transformedMenu });
        setMiniSidebar(dispatch, true);

        if (menuDetails[0]?.routingPath) {
          navigate(menuDetails[0].routingPath, { replace: true }); // Redirect to HRMS
        } else {
          throw new Error("Invalid HRMS module data. No routing path available.");
        }
      } catch (hrmsError) {
        setAlert(hrmsError.message || "Something went wrong", "error");
        navigate("/landing-page", { replace: true }); // Fallback to landing page
      }

      // Clear form
      setUsername("");
      setPassword("");

      // Fetch HRMS menu and navigate
      const hrmsModuleId = 3; // HRMS module ID
      const menuResponse = await fetch(
        `${URLs.userManuByModuleId}?employeeId=${loginData.employeeId}&moduleId=${hrmsModuleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${loginData.jwtToken}`,
          },
        }
      );

      if (!menuResponse.ok) {
        throw new Error("Failed to fetch HRMS menu");
      }

      const menuDetails = await menuResponse.json();

      if (!menuDetails || menuDetails.length === 0) {
        throw new Error("You are not authorized to access HRMS module");
      }

      // Transform menu data
      const transformedMenu = transformData(menuDetails);

      // Find first available route
      let firstRoute = null;
      for (const menu of transformedMenu) {
        if (menu.type === "collapse" && menu.route) {
          firstRoute = menu.route;
          break;
        } else if (menu.type === "dropdown" && menu.collapse && menu.collapse[0]?.collapse) {
          const firstChild = menu.collapse[0].collapse[0];
          if (firstChild?.route) {
            firstRoute = firstChild.route;
            break;
          }
        }
      }

      if (!firstRoute) {
        throw new Error("No accessible HRMS routes found");
      }

      // Set menu in user context and navigate
      const userObjectWithMenu = {
        ...userObject,
        menu: transformedMenu,
      };
      setUser(dispatch, userObjectWithMenu);
      navigate(firstRoute);
    } catch (error) {
      console.error("Login error:", error);
      setAlert(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleChange = (event, newValue) => {
    if (newValue) {
      setUsername(newValue);
    }
  };

  // const transformData = (data) => {
  //   if (!Array.isArray(data)) return [];

  //   const result = [];
  //   const groupedMap = new Map();
  //   const moduleIcons = {
  //     Dashboard: <MdSpaceDashboard />,
  //     "Business Masters": <MdBusinessCenter />,
  //     "Business Forms": <MdArticle />,
  //     "Month End": <MdEventRepeat />,
  //     "Account Masters": <MdAccountBalanceWallet />,
  //     Vouchers: <MdReceiptLong />,
  //     "Business Reports": <MdAssessment />,
  //     Reports: <MdAssessment />,
  //     HRMS: <MdPeopleAlt />,
  //     "Head Office": <RiGovernmentLine />,
  //     "Home Page": <MdHome />,
  //     EmployeeLetterDesk: <MdWorkOutline />,
  //     Approvals: <FiCheckSquare />,
  //     Admin: <MdAdminPanelSettings />,
  //     "My Desk": <MdOutlineDesk />,
  //     "Invoice Management": <MdOutlineRequestQuote />,
  //     "Payment Processing": <MdPayment />,
  //     MIS: <MdMiscellaneousServices />,
  //     "Company Setup": <MdOutlineSettings />,
  //     Access: <MdSecurity />,
  //     "Provider & DSA Operations": <MdCorporateFare />,
  //     "Pre Joining": <MdOutlineHowToReg />,
  //     "Payroll Management": <MdOutlineAccountBalance />,
  //     Profiles: <MdPerson />,
  //     Invoices: <MdOutlineRequestQuote />,
  //     Operation: <MdTaskAlt />,
  //     Analytics: <MdAnalytics />,
  //     "Data Setup": <MdPostAdd />,
  //     "Post Joining": <MdOutlineHowToReg />,
  //     Payroll: <MdOutlineAccountBalance />,
  //     "Review & Approvals": <MdFactCheck />,
  //   };

  //   data.forEach((item) => {
  //     if (!item) return;

  //     const { mainMenuId, mainMenu, subMenuId, subMenuName, routingPath, type, icon, component } =
  //       item;

  //     if (!mainMenuId || !mainMenu) return;

  //     if (!groupedMap.has(mainMenuId)) {
  //       groupedMap.set(mainMenuId, {
  //         mainMenuId,
  //         mainMenu,
  //         children: [],
  //       });
  //     }

  //     if (subMenuId && subMenuName && routingPath) {
  //       groupedMap.get(mainMenuId).children.push({
  //         subMenuId,
  //         subMenuName,
  //         routingPath,
  //         type,
  //         menuKey: subMenuName.toLowerCase().replace(/\s+/g, "-"),
  //         icon,
  //         component,
  //       });
  //     }
  //   });

  //   groupedMap.forEach((group) => {
  //     if (group.children.length === 1) {
  //       const child = group.children[0];
  //       result.push({
  //         type: "collapse",
  //         name: group.mainMenu,
  //         key: child.menuKey,
  //         route: child.routingPath,
  //         icon: <Icon fontSize="small">{child.icon}</Icon>,
  //         component: child.component,
  //       });
  //     } else {
  //       result.push({
  //         type: "dropdown",
  //         name: group.mainMenu,
  //         key: group.mainMenu.toLowerCase().replace(/\s+/g, "-"),
  //         icon: moduleIcons[group.mainMenu],
  //         collapse: [
  //           {
  //             type: "collapse",
  //             name: "",
  //             key: "",
  //             collapse: group.children.map((child) => ({
  //               type: "collapse",
  //               name: child.subMenuName,
  //               key: child.menuKey,
  //               route: child.routingPath,
  //               icon: <Icon fontSize="small">{child.icon}</Icon>,
  //               component: child.component,
  //             })),
  //           },
  //         ],
  //       });
  //     }
  //   });

  //   return result;
  // };

  const revolveOneKeyframes = {
    "0%": {
      transform: "rotate(0deg) translateX(clamp(100px, 15vw, 150px)) rotate(0deg)",
    },
    "50%": {
      transform: "rotate(180deg) translateX(clamp(100px, 15vw, 150px)) rotate(-180deg)",
    },
    "100%": {
      transform: "rotate(360deg) translateX(clamp(100px, 15vw, 150px)) rotate(-360deg)",
    },
  };

  const revolveTwoKeyframes = {
    "0%": {
      transform: "rotate(0deg) translateX(clamp(150px, 20vw, 200px)) rotate(0deg)",
    },
    "50%": {
      transform: "rotate(-180deg) translateX(clamp(150px, 20vw, 200px)) rotate(180deg)",
    },
    "100%": {
      transform: "rotate(-360deg) translateX(clamp(150px, 20vw, 200px)) rotate(-360deg)",
    },
  };

  return (
    <Grid
      container
      sx={{
        width: "100%",
        height: "100vh",
        background: "linear-gradient(to bottom right, #f5f7fa, rgb(192, 13, 13))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxHeight: "100vh",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            padding: "clamp(10px, 2vw, 20px)",
            minWidth: "clamp(200px, 30vw, 300px)",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "clamp(10px, 2vw, 20px)",
          }}
        >
          <CircularProgress color="primary" size="clamp(24px, 4vw, 40px)" />
          <Typography variant="h6" sx={{ fontSize: "clamp(14px, 2vw, 20px)" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
        sx={{
          width: "clamp(250px, 50vw, 400px)",
          top: "clamp(10px, 2vh, 20px)",
        }}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>

      {/* Right Side - Login Form with Circle Animation */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          height: { xs: "50%", sm: "70%", md: "100%" },
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          padding: "clamp(10px, 2vw, 20px)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background Animation - Revolving Circles */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 0,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: { xs: "clamp(150px, 25vw, 200px)", md: "clamp(250px, 30vw, 300px)" },
              height: { xs: "clamp(150px, 25vw, 200px)", md: "clamp(250px, 30vw, 300px)" },
              borderRadius: "50%",
              border: "4px solid rgba(206, 9, 9, 0.6)",
              opacity: 0.6,
              animation: "revolveOne 6s infinite ease-in-out",
              "@keyframes revolveOne": revolveOneKeyframes,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              width: { xs: "clamp(200px, 35vw, 300px)", md: "clamp(300px, 40vw, 400px)" },
              height: { xs: "clamp(200px, 35vw, 300px)", md: "clamp(300px, 40vw, 400px)" },
              borderRadius: "50%",
              border: "4px solid rgba(255, 255, 255, 0.5)",
              opacity: 0.5,
              animation: "revolveTwo 8s infinite ease-in-out",
              "@keyframes revolveTwo": revolveTwoKeyframes,
            }}
          />
        </Box>

        <Paper
          elevation={8}
          sx={{
            borderRadius: "clamp(10px, 2vw, 15px)",
            padding: { xs: "clamp(15px, 3vw, 20px)", md: "clamp(25px, 4vw, 40px)" },
            width: "100%",
            maxWidth: "clamp(300px, 60vw, 450px)",
            background: "rgba(255, 255, 255, 0.95)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            border: "1px solid rgba(139, 0, 0, 0.1)",
            position: "relative",
            zIndex: 1,
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a href="https://www.sconexsoft.com" target="_blank" rel="noopener noreferrer">
              <Box
                component="img"
                src={image}
                alt="Brand Logo"
                sx={{
                  height: {
                    xs: "32px",
                    sm: "48px",
                    md: "clamp(64px, 8vh, 80px)",
                  },
                  width: "100%",
                  maxWidth: "clamp(120px, 30vw, 240px)",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
              />
            </a>
          </Box>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Username"
              variant="outlined"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <FormControlLabel
              control={<Checkbox checked={rememberMe} onChange={handleSetRememberMe} />}
              label="Remember Me"
              sx={{
                mb: "clamp(10px, 2vh, 20px)",
                color: "#2b2d42",
                "& .MuiTypography-root": {
                  fontSize: "clamp(12px, 1.5vw, 16px)",
                },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: "clamp(10px, 2vh, 20px)",
                py: "clamp(8px, 1.5vh, 15px)",
                borderRadius: "4 clamp(6px, 1vw, 8px) clamp(6px, 1vw, 8px) 0",
                backgroundColor: "#D32F2F",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#D32F2F",
                },
                textTransform: "none",
                fontSize: "clamp(14px, 1.5vw, 18px)",
                fontWeight: "bold",
                boxShadow: "0 4px 15px rgba(139,0,0,0.3)",
              }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size="clamp(20px, 3vw, 24px)" sx={{ color: "#FFFFFF" }} />
              ) : (
                "Sign In"
              )}
            </Button>
          </form>
        </Paper>
      </Grid>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          position: "absolute",
          bottom: "clamp(10px, 2vh, 20px)",
          right: "clamp(180px, 12vw, 180px)",
          width: "100%",
        }}
      ></Box>
    </Grid>
  );
}
export default LoginPage;
